import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const TambahStok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isStokExist, setIsStokExist] = useState(false);

  const [kodeStok, setKodeStok] = useState("");
  const [barcodeStok, setBarcodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [namaPanggilanStok, setNamaPanggilanStok] = useState("");
  const [merkStok, setMerkStok] = useState("");
  const [satuanKecilStok, setSatuanKecilStok] = useState("");
  const [satuanBesarStok, setSatuanBesarStok] = useState("");
  const [konversiStok, setKonversiStok] = useState("");
  const [hargaJualStok, setHargaJualStok] = useState("");
  const [kodeGroupStok, setKodeGroupStok] = useState("");

  const [groupStoks, setGroupStoks] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let groupStokOptions = groupStoks.map((groupStok) => ({
    label: `${groupStok.kodeGroupStok} - ${groupStok.namaGroupStok}`,
  }));

  useEffect(() => {
    getGroupStokData();
  }, []);

  const getGroupStokData = async () => {
    const response = await axios.post(`${tempUrl}/groupStoks`, {
      _id: user.id,
      token: user.token,
    });
    setGroupStoks(response.data);
  };

  const getStokNextKode = async (kodeGroupStok) => {
    const response = await axios.post(`${tempUrl}/stoksNextKode`, {
      kodeGroupStok: kodeGroupStok.split(" ", 1)[0],
      _id: user.id,
      token: user.token,
    });
    setKodeStok(response.data);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    if (response.data) {
      setIsStokExist(true);
      alert(
        `Data Barcode sudah ada dengan Kode Stok: ${response.data.kodeStok}, dan Nama Stok ${response.data.namaStok}`,
      );
    } else {
      setIsStokExist(false);
      alert(`Barcode belum ada`);
    }
  };

  const saveStok = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isStokExist) {
      alert(`Data tidak bisa disimpan karena barcode sudah ada!`);
      return;
    }

    const form = e.currentTarget;
    if (form.checkValidity() && kodeGroupStok.length !== 0) {
      setLoading(true);
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/saveStok`, {
          barcodeStok,
          namaStok,
          namaPanggilanStok,
          merkStok,
          satuanKecilStok,
          satuanBesarStok,
          konversiStok,
          hargaJualStok,
          kodeGroupStok: kodeGroupStok.split(" ", 1)[0],
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate("/stok");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Stok</h5>
      <hr />
      <Card>
        <Card.Header>Stok</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={saveStok}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Group Stok <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={groupStokOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeGroupStok.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeGroupStok(value.label);
                          getStokNextKode(value.label);
                        } else {
                          setKodeGroupStok("");
                        }
                      }}
                      value={kodeGroupStok}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={kodeStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Barcode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={barcodeStok}
                      onChange={(e) => setBarcodeStok(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === "Tab") {
                          e.preventDefault();
                          // alert("Enter pressed on kodeStok");
                          getFindStok(e.target.value);
                        }
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={namaStok}
                      onChange={(e) => setNamaStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Panggilan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={namaPanggilanStok}
                      onChange={(e) => setNamaPanggilanStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Merk :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={merkStok}
                      onChange={(e) => setMerkStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Kecil <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={satuanKecilStok}
                      onChange={(e) => setSatuanKecilStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Besar <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={satuanBesarStok}
                      onChange={(e) => setSatuanBesarStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Konversi <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={konversiStok}
                      onChange={(e) => setKonversiStok(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Harga Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <NumericFormat
                      required
                      value={hargaJualStok}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setHargaJualStok(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, ""),
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/stok")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahStok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const colorRed = {
  color: "red",
};
